import { opportunityData } from "configs/opportunity.config";
import { states } from "configs/states.config";
import { z } from "zod";

export const schema = z.object({
  fullname: z.string().min(1, "This field is required"),
  email: z.string().email().min(1, "This field is required"),
  phone_number: z.number(),
  title: z.string(),
  company: z.string(),
  address: z.string().min(1, "This field is required"),
  country: z.string().min(1, "This field is required"),
  state_or_province: z.string().min(1, "This field is required"),
  city: z.string().min(1, "This field is required"),
  postal_code: z.string().min(1, "This field is required"),
  license_number: z.string(),
});

const profileFields = [
  {
    label: "Name",
    name: "fullname",
    required: true,
  },
  {
    label: "Email",
    name: "email",
    disabled: true,
    required: true,
  },
  {
    label: "Phone Number",
    name: "phone_number",
    type: "number",
  },
  {
    label: "Job Title",
    name: "title",
  },
  {
    label: "Company Name",
    name: "company",
  },
  {
    label: "Address",
    name: "address",
    required: true,
  },
  {
    label: "Company Country",
    name: "country",
    component: "list",
    list: opportunityData.companyCountryList,
    dependent: ["state_or_province"],
    required: true,
  },
  {
    label: "State / Province",
    name: "state_or_province",
    component: "list",
    list: ({ country }) => states[country],
    required: true,
  },
  {
    label: "City",
    name: "city",
    required: true,
  },
  {
    label: "Postal Code",
    name: "postal_code",
    required: true,
  },
  {
    label: "License Number",
    name: "license_number",
  },
];

export default profileFields;
